export const VPC_TYPE = 'VerifiedParentalConsent';
export const APPROVED_STATE = 'Approved';
export const PENDING_STATE = 'Pending';

export const PERMISSION_KEYS = {
  VIEW_BASE_TEAM_FEATURES: 'can_view_base_team_features',
  CREATE_HIGHLIGHT: 'can_create_highlight',
  ACCESS_SOCIAL_INTERACTIONS: 'can_access_social_interactions',
  PROFILE_IS_PUBLIC: 'profile_is_public',
  EDIT_RECRUITABLE_INFORMATION: 'can_edit_recruitable_information',
};

export const FEATURES = [
  { key: 'teamSpace', permissionKey: PERMISSION_KEYS.VIEW_BASE_TEAM_FEATURES, ageTiers: ['Under13'] },
  { key: 'highlights', permissionKey: PERMISSION_KEYS.CREATE_HIGHLIGHT, ageTiers: null },
  { key: 'favorites', permissionKey: PERMISSION_KEYS.ACCESS_SOCIAL_INTERACTIONS, ageTiers: null },
  { key: 'publicProfile', permissionKey: PERMISSION_KEYS.PROFILE_IS_PUBLIC, ageTiers: null },
  { key: 'recruit', permissionKey: PERMISSION_KEYS.EDIT_RECRUITABLE_INFORMATION, ageTiers: ['Under18'] },
];

/**
 * Summarizes VPC consent records: any Approved record wins (with all approved guardian emails),
 * otherwise the oldest Pending record. Any other state yields no CTA.
 */
export function getConsentSummary(consentStatuses) {
  const vpcEntries = (consentStatuses || []).filter(s => s.type === VPC_TYPE);
  const approvedEmails = vpcEntries
    .filter(s => s.state === APPROVED_STATE)
    .map(e => e.providerEmail)
    .join(', ');
  const isApproved = approvedEmails.length > 0;
  const pendingEntry = isApproved ? null : (vpcEntries
    .filter(s => s.state === PENDING_STATE)
    .sort((a, b) => new Date(a.dateCreated) - new Date(b.dateCreated))[0] || null);

  return { isApproved, approvedEmails, pendingEntry };
}

export function isPermissionOn(selfPermissions, permissionKey) {
  return (selfPermissions || []).some(p => p.key === permissionKey && p.value === 'true');
}
